import { FC } from "react";
import { useI18n } from "../../hooks/useTranslations";
import { useLeasingCompaniesApi } from "../../http/leasingCompanies/api";
import HistoryDialog from "../ui/HistoryDialog";
import Textarea from "../ui/Textarea";
import VersionDialog from "../ui/VersionDialog";

type LeasingCompanyHistoryDialogProps = {
  itemToShowVersionsId: string;
  itemVersionToShowVersions: number;
  onClose: () => void;
};

const LeasingCompanyHistoryDialog: FC<LeasingCompanyHistoryDialogProps> = ({
  itemToShowVersionsId,
  itemVersionToShowVersions,
  onClose,
}) => {
  const i18n = useI18n();
  const leasingCompaniesApi = useLeasingCompaniesApi();

  return (
    <HistoryDialog
      title={i18n.t.leasingCompanies.versions}
      lastVersion={itemVersionToShowVersions}
      entityId={itemToShowVersionsId}
      getEntityVersionHook={leasingCompaniesApi.getAdminLeasingCompanyVersion}
      getHistory={leasingCompaniesApi.getAdminLeasingCompanyHistory}
      onClose={onClose}
      renderForm={(headers, dataVersion) => (
        <>
          <VersionDialog.Table headers={headers}>
            {dataVersion.current.name != dataVersion.next.name && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.name}
                  value={dataVersion.current?.name}
                  edited={dataVersion.next.name}
                />
              </tr>
            )}
            {dataVersion.current.address != dataVersion.next.address && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.address}
                  value={dataVersion.current?.address}
                  edited={dataVersion.next.address}
                />
              </tr>
            )}
            {dataVersion.current.email != dataVersion.next.email && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.email}
                  value={dataVersion.current?.email}
                  edited={dataVersion.next.email}
                />
              </tr>
            )}
            {dataVersion.current.phoneNumber != dataVersion.next.phoneNumber && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.phoneNumber}
                  value={dataVersion.current?.phoneNumber}
                  edited={dataVersion.next.phoneNumber}
                />
              </tr>
            )}
            {dataVersion.current?.notes != dataVersion.next.notes && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.notes}
                  value={
                    dataVersion.current && (
                      <Textarea
                        value={dataVersion.current && !dataVersion.current?.notes ? "" : dataVersion.current?.notes}
                        disabled
                      />
                    )
                  }
                  edited={<Textarea value={dataVersion.next.notes} disabled />}
                />
              </tr>
            )}
          </VersionDialog.Table>
        </>
      )}
    />
  );
};

export default LeasingCompanyHistoryDialog;
